import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './components/translate/en/translation.json';
import esTranslations from './components/translate/es/translation.json';
import euTranslations from './components/translate/eu/translation.json';

/**
 * Inicializa la configuración de i18next para la internacionalización.
 * 
 * - Define los recursos de traducción para los idiomas inglés (en), español (es) y euskera (eu).
 * - Establece el idioma por defecto en español ('es').
 * - Define el idioma de reserva (fallback) también como español.
 * - Configura la interpolación para no escapar valores.
 */
i18n.use(initReactI18next).init({
    resources: {
        en: { translation: enTranslations },
        es: { translation: esTranslations },
        eu: { translation: euTranslations }
    },
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
        escapeValue: false
    }
});

export default i18n;
